export default "/biometrie-afghanistan/media/c84bce67883b6f773be2e53dced25532~said.jpg";